import _ from 'lodash';
import React from 'react';
import { InvoiceStatusFilter } from '~/components';
import AccountingIntegrationFilter from '~/components/filters/AccountingIntegrationFilter';
import InvoiceSentFilter from '~/components/filters/InvoiceSentFilter';
import { useIntegrations } from '~/contexts/IntegrationsContext';
import FiltersGroup from './FiltersGroup';
import InvoiceItemFilter from './InvoiceItemFilter';
import ReportPeriodFilter from './ReportPeriodFilter';

export default function InvoiceFiltersGroup({ filters, onChange }) {
  const integrations = useIntegrations();
  return (
    <FiltersGroup
      label="Invoice Filters"
      filters={[
        filters.invoiceServicesThroughPeriod?.start,
        filters.invoiceServicesThroughPeriod?.end,
        filters.invoiceStatuses,
        filters.invoiceSent,
        filters.invoiceItems,
        filters.invoiceAccountingIntegrations,
      ]}>
      {_.has(filters, 'invoiceServicesThroughPeriod') && (
        <ReportPeriodFilter
          value={filters.invoiceServicesThroughPeriod}
          placeholder="Services Through Date Range"
          onChange={({ target: { value } }) => onChange({ invoiceServicesThroughPeriod: value })}
        />
      )}

      {_.has(filters, 'invoiceStatuses') && (
        <InvoiceStatusFilter
          value={filters.invoiceStatuses}
          onChange={({ target: { value } }) => onChange({ invoiceStatuses: value })}
        />
      )}

      {_.has(filters, 'invoiceSent') && (
        <InvoiceSentFilter
          value={filters.invoiceSent}
          onChange={({ target: { value } }) => onChange({ invoiceSent: value })}
        />
      )}

      {_.has(filters, 'invoiceItems') && (
        <InvoiceItemFilter
          value={filters.invoiceItems}
          onChange={({ target: { value } }) => onChange({ invoiceItems: value })}
        />
      )}

      {integrations.accounting && _.has(filters, 'invoiceAccountingIntegrations') && (
        <AccountingIntegrationFilter
          value={filters.invoiceAccountingIntegrations}
          onChange={({ target: { value } }) => onChange({ invoiceAccountingIntegrations: value })}
        />
      )}
    </FiltersGroup>
  );
}
